import createUnsubscribedContactRedux from 'Modules/unsubscribedContacts/.components/createUnsubscribedContact/redux/reducer';
import deleteUnsubscribedContactRedux from 'Modules/unsubscribedContacts/.components/deleteUnsubscribedContact/redux/reducer';



//export redux objects
export default {
	createUnsubscribedContactRedux,
	deleteUnsubscribedContactRedux,
};